<template>
  <CardedForm
    ref="rate_business_form_ref"
    id="rate_business_form"
    title="_"
    :is_loading="is_loading || is_owner"
    @on-submit-form="submit"
    :errors="errors"
    :message="message"
    @on-auto-fill="on_auto_fill"
    @on-close-message="on_hide_message"
    @on-clear-form="on_form_cleared"
  >
    <v-alert dense text type="warning" v-if="is_owner">
      Please note that you <strong> can not rate your own business</strong>
    </v-alert>

    <v-alert dense text type="warning" v-if="!is_owner && previous_rate > -1">
      You previously rated this business
      <strong>{{ previous_rate }} stars</strong>
    </v-alert>
    <v-rating
      background-color="warning lighten-1"
      color="warning"
      empty-icon="mdi-star-outline"
      full-icon="mdi-star"
      half-icon="mdi-star-half-full"
      hover
      length="5"
      size="50"
      v-model="form.rate"
      :readonly="is_owner || is_loading"
    ></v-rating>
    <br />
  </CardedForm>
</template>

<script>
import CardedForm from "./../components/CardedForm";
import ServerClient from "./../lib/ServerClient";
import Utils from "./../lib/Utils";
export default {
  name: "BusinessViewRateForm",
  components: {
    CardedForm,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    user: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data: function () {
    return {
      errors: [],
      message: "",
      form: {
        rate: 0,
      },
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 6);
      this.form.rate = rnd >= 6 ? 0 : rnd;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.form.rate = 0;
      this.errors = [];
      this.message = "";
    },
    on_form_cleared() {
      this.init_form();
    },
    submit() {
      if (
        this.user == null ||
        this.user == undefined ||
        parseInt(this.user.id) == 0
      ) {
        ServerClient.set_temp_rate(this.form.rate);
        this.$emit("on-not-loggedin", this.form.rate);
        return false;
      }
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.post_business_rate(
        {
          ...this.form,
          business_id: this.business_id,
          user_id: this.user.id,
        },
        (res) => {
          //console.log("Items ", res);
          this.items = res;
          this.$refs.rate_business_form.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  Thank you <b>" +
            this.user.first_name +
            " " +
            this.user.last_name +
            "</b> for rating this business ";
          this.$refs.rate_business_form.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.rate_business_form.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      this.$emit("on-success-rated");
    },
  },
  computed: {
    previous_rate() {
      var prev = -1;
      if (
        this.business &&
        this.business.ratings &&
        this.business.ratings.length > 0 &&
        this.user != null
      ) {
        for (var index = 0; index < this.business.ratings.length; index++) {
          var rate = this.business.ratings[index];
          if (parseInt(rate.user_id) == parseInt(this.user.id)) {
            prev = parseFloat(rate.rate);
            break;
          }
        }
      }
      return prev;
    },
  },
  mounted() {
    var temp_rate = ServerClient.get_temp_rate();
    var has_just_rate_logged_in = ServerClient.get_has_just_rate_logged_in();
    // console.log(
    //   "has_just_rate_logged_in: ",
    //   temp_rate,
    //   has_just_rate_logged_in
    // );
    ServerClient.clear_temp_rate();
    if (
      has_just_rate_logged_in == "true" &&
      this.user &&
      this.user != null &&
      parseInt(this.user.id) > 0 &&
      this.is_owner == false
    ) {
      //we can auto post for this user the rate
      this.form.rate = parseFloat(temp_rate);
      this.submit();
    }
  },
};
</script>